import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class GigActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/Services/GigBrowser")
	}

	render() {
		return (
			<Activity 
				name="gig_admin"
				RenderedComponent={this.RenderedComponent}
				context="gig_admin"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(GigActivity)
